import React from "react";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const clientDashboardNav = [
  {
    key: "overview",
    label: "Overview",
    description: "Dashboard summary",
    icon: <DashboardIcon fontSize="small" />,
  },
  {
    key: "engagements",
    label: "Engagements",
    description: "Spending and contracts",
    icon: <AccountBalanceWalletIcon fontSize="small" />,
  },
  {
    key: "billing",
    label: "Billing",
    description: "Invoices and payments",
    icon: <ReceiptLongIcon fontSize="small" />,
  },
];

export default clientDashboardNav;

